// jQuery_T4NT(document).ready(function($) {

//      /**
//      *  Variant selection changed
//      *  data-variant-toggle="{{ variant.id }}"
//      */
// 	   $( document ).on( "variant:changed", function( evt ) {
// 	     // console.log( evt.currentVariant );
// 	     // $('[data-variant-toggle]').hide(0);
// 	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
// 	   });
  

// });


$( document ).ready(function() {
       $(window).scroll(function() {
  jQuery('span.t4s-pr-color__item').each(function(){
   var newr = jQuery(this).find("span.t4s-pr-color__name").text(); 
  
     if(newr=='Chrome'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#757575" );
      
  }
  if(newr=='Matte Black'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#28282B" );
      
  }
      if(newr=='Matt Black'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#28282B" );
      
  }
      if(newr=='Matte White'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#FDFBF9" );
      
  }
 
  if(newr=='Brushed Nickel'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#73706f" );
      
  }
 
     if(newr=='Urban Brass'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#D0AC6F" );
      
  }
      if(newr=='Gun Metal'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#565654" );
      
  }
        if(newr=='Gunmetal'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#565654" );
      
  }
    
    if(newr=='White'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#FCFAF5" );
      
  }
     if(newr=='Rose Gold'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#D39D91" );
      
  }
    if(newr=='Brushed Gold'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#897750" );
      
  }
    
   if(newr=='Brushed Yellow Gold'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#CCBA78" );
      
  }
  if(newr=='Concrete Grey'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#808076" );
      
  }
   if(newr=='Dark Grey'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#0a0a0e" );
      
  }
   if(newr=='Gun Metal Grey'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#8D918D" );
      
  }
    
  if(newr=='Gunmetal Grey'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#8D918D" );
      
  }
    
    if(newr=='Black Rose Gold'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#232323" );
      
  }
   
  if(newr=='Gloss White'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#FFFDFA" );
      
  }
    
   if(newr=='Brushed Yellow'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#b38b5e" );
   }    
     if(newr=='Wood'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#966F33" );
   }   
    
   if(newr=='Polished Mirror'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#aab7aa" );
   }   
     if(newr=='Satin Black'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#0F0701" );
   }   
     if(newr=='Satin White'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#e5e6de" );
   } 

   if(newr=='Chrome/Matt Black'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(to bottom, #757575 50%, #28282b 100%)");
   } 
    
   if(newr=='Matt Black/Chrome'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(to right, #757575 50%, #28282b 100%)");
   } 
    
   if(newr=='Gloss Black'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#252324" );
   } 
    
     if(newr=='Gloss Black and white'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(to bottom, #252324 50%, #ffffff 100%)");
   } 
      if(newr=='Matt Rose Gold'){
$(this).find('.t4s-pr-color__value').css( "background", "#ab724c");
   } 
  if(newr=='Matte Gray'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#98989c" );
      
  }  
   if(newr=='Matt White'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#f5f0f0" ); 
  }  
    
  if(newr=='Blush Pink'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#FE828C" ); 
}
    
if(newr=='Charcoal'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#36454F" ); 
}
    
if(newr=='Clay'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#996633" ); 
}
    
if(newr=='Copan Blue'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#C4CFC7" ); 
}
    
if(newr=='Custard'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#ebdcc3" ); 
}
    
if(newr=='Ivory'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#FFFFF0" ); 
}

if(newr=='Mid Tone Grey'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#8b8680" ); 
}
    
if(newr=='Mint'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#3EB489" ); 
}
    
if(newr=='Musk'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#C06A01" ); 
}
    
if(newr=='Pastel Peach'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#F7DFC2" ); 
}
    
if(newr=='Powder Blue'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#b0e0e6" ); 
}
    
if(newr=='Sand'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#C2B280" ); 
}
    
if(newr=='Sky Grey'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#a5b7bd" ); 
}
    
if(newr=='Teal'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#008080" ); 
}
    
 if(newr=='Matte Black & Rose Gold'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#994c62" ); 
} 
    
 if(newr=='Matt Black & Rose Gold'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#994c62" ); 
}
 
if(newr=='Autumn'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#DE8C3C" ); 
}
    
if(newr=='Blossom'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#fee9d8" ); 
}
    
if(newr=='Warm White'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#FDF4DC" ); 
}

 if(newr=='Matte Black/ Gun Metal'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#141617" ); 
}
    
if(newr=='Gun Metal / Matte Black'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#625a56" ); 
}
 
if(newr=='Matte Black White'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#bababa" ); 
}

if(newr=='Brushed Nickel White'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#73706f" ); 
}

if(newr=='Urban Brass White'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#bd9c6e" ); 
}
    
if(newr=='Champagne'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#F7E7CE" ); 
}
    
if(newr=='Chrome and Black'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#cfcfcf" ); 
} 

if(newr=='Matte Pink'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#D288A2" ); 
}

if(newr=='Silver Ring'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#C0C0C0" ); 
} 
 
if(newr=='Matte Blue'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#4b6f83" ); 
}

if(newr=='Matte Dark Grey'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#292a2e" ); 
}

if(newr=='Matte Green'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#599e89" ); 
}

if(newr=='Matte Black/ Brushed Nickel'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#302f34" ); 
}

if(newr=='Matte Black/ Chrome'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#323337" ); 
}
    
if(newr=='Brushed Nickel / Matte Black'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#c7c3be" ); 
}

if(newr=='Matte Black/ Urban Brass'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#cdd3d7" ); 
}

if(newr=='Chrome / Matte Black'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#312a22" ); 
}

if(newr=='Urban Brass / Matte Black'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#d7ccaf" ); 
}
    
if(newr=='Brass'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#B5A642" ); 
}
    
 if(newr=='Black Gold'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#281C02" ); 
}

 if(newr=='Gloss Black and white'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#efefef" ); 
}
    
 if(newr=='Urban Brass with Matte Black'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#efefef" ); 
} 
    
    if(newr=='Wood'){
$(this).find('.t4s-pr-color__value').css( "background-color", "#966F33" ); 
} 
    if(newr=='Chrome & Matte Black'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(328deg, rgba(40,40,43,1) 50%, rgba(117,117,117,1) 50%)" ); 
}
 if(newr=='Chrome & White'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(328deg, rgba(255,255,255,1) 50%, rgba(117,117,117,1) 50%)" ); 
}
          
 if(newr=='Chrome and Black'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(328deg, rgba(0,0,0,1) 50%, rgba(117,117,117,1) 50%)" ); 
}
 if(newr=='Matt black and white'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(328deg, rgba(23,23,23,1) 50%, rgba(255,255,255,1) 50%)" ); 
}                
          
 if(newr=='Black and Copper'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(328deg, rgba(0,0,0,1) 50%, rgba(184,115,51,1) 50%)" ); 
}          

 if(newr=='White and Copper'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(328deg, rgba(255,255,255,1) 50%, rgba(184,115,51,1) 50%)" ); 
}  
       
 if(newr=='Matte Black and White'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(328deg, rgba(23,23,23,1) 50%, rgba(255,255,255,1) 50%)" ); 
}  

 if(newr=='Matte White & Black'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(328deg, rgba(23,23,23,1) 50%, rgba(255,255,255,1) 50%)" ); 
}     
 if(newr=='White & Black'){
$(this).find('.t4s-pr-color__value').css( "background", "linear-gradient(328deg, rgba(255,255,255,1) 50%, rgba(0,0,0,1) 50%)" ); 
}    
});
     });



jQuery('.t4s-swatch__list .t4s-swatch__item').each(function(){
  var value = jQuery(this).text();
      $(this).addClass('color_div');
       if(value=='Chrome'){
  $(this).css( "background-color", "#757575" );
        
    }
    if(value=='Matte Black'){
  $(this).css( "background-color", "#28282B" );
        
    }
        if(value=='Matt Black'){
  $(this).css( "background-color", "#28282B" );
        
    }
        if(value=='Matte White'){
  $(this).css( "background-color", "#FDFBF9" );
        
    }
   
    if(value=='Brushed Nickel'){
  $(this).css( "background-color", "#73706f" );
        
    }
   
       if(value=='Urban Brass'){
  $(this).css( "background-color", "#D0AC6F" );
        
    }
        if(value=='Gun Metal'){
  $(this).css( "background-color", "#565654" );
        
    }
          if(value=='Gunmetal'){
  $(this).css( "background-color", "#565654" );
        
    }
      
      if(value=='White'){
  $(this).css( "background-color", "#FCFAF5" );
        
    }
       if(value=='Rose Gold'){
  $(this).css( "background-color", "#D39D91" );
        
    }
      if(value=='Brushed Gold'){
  $(this).css( "background-color", "#897750" );
        
    }
      
     if(value=='Brushed Yellow Gold'){
  $(this).css( "background-color", "#CCBA78" );
        
    }
    if(value=='Concrete Grey'){
  $(this).css( "background-color", "#808076" );
        
    }
     if(value=='Dark Grey'){
  $(this).css( "background-color", "#0a0a0e" );
        
    }
     if(value=='Gun Metal Grey'){
  $(this).css( "background-color", "#8D918D" );
        
    }
      
    if(value=='Gunmetal Grey'){
  $(this).css( "background-color", "#8D918D" );
        
    }
      
      if(value=='Black Rose Gold'){
  $(this).css( "background-color", "#232323" );
        
    }
     
    if(value=='Gloss White'){
  $(this).css( "background-color", "#FFFDFA" );
        
    }
      
     if(value=='Brushed Yellow'){
  $(this).css( "background-color", "#b38b5e" );
     }    
       if(value=='Wood'){
  $(this).css( "background-color", "#966F33" );
     }   
      
     if(value=='Polished Mirror'){
  $(this).css( "background-color", "#aab7aa" );
     }   
       if(value=='Satin Black'){
  $(this).css( "background-color", "#0F0701" );
     }   
       if(value=='Satin White'){
  $(this).css( "background-color", "#e5e6de" );
     } 
  
     if(value=='Chrome/Matt Black'){
  $(this).css( "background", "linear-gradient(to bottom, #757575 50%, #28282b 100%)");
     } 
      
     if(value=='Matt Black/Chrome'){
  $(this).css( "background", "linear-gradient(to right, #757575 50%, #28282b 100%)");
     } 
      
     if(value=='Gloss Black'){
  $(this).css( "background-color", "#252324" );
     } 
      
       if(value=='Gloss Black and white'){
  $(this).css( "background", "linear-gradient(to bottom, #252324 50%, #ffffff 100%)");
     } 
        if(value=='Matt Rose Gold'){
  $(this).css( "background", "#ab724c");
     } 
    if(value=='Matte Gray'){
  $(this).css( "background-color", "#98989c" );
        
    }  
     if(value=='Matt White'){
  $(this).css( "background-color", "#f5f0f0" ); 
    }  
      
    if(value=='Blush Pink'){
  $(this).css( "background-color", "#FE828C" ); 
  }
      
  if(value=='Charcoal'){
  $(this).css( "background-color", "#36454F" ); 
  }
      
  if(value=='Clay'){
  $(this).css( "background-color", "#996633" ); 
  }
      
  if(value=='Copan Blue'){
  $(this).css( "background-color", "#C4CFC7" ); 
  }
      
  if(value=='Custard'){
  $(this).css( "background-color", "#ebdcc3" ); 
  }
      
  if(value=='Ivory'){
  $(this).css( "background-color", "#FFFFF0" ); 
  }
  
  if(value=='Mid Tone Grey'){
  $(this).css( "background-color", "#8b8680" ); 
  }
      
  if(value=='Mint'){
  $(this).css( "background-color", "#3EB489" ); 
  }
      
  if(value=='Musk'){
  $(this).css( "background-color", "#C06A01" ); 
  }
      
  if(value=='Pastel Peach'){
  $(this).css( "background-color", "#F7DFC2" ); 
  }
      
  if(value=='Powder Blue'){
  $(this).css( "background-color", "#b0e0e6" ); 
  }
      
  if(value=='Sand'){
  $(this).css( "background-color", "#C2B280" ); 
  }
      
  if(value=='Sky Grey'){
  $(this).css( "background-color", "#a5b7bd" ); 
  }
      
  if(value=='Teal'){
  $(this).css( "background-color", "#008080" ); 
  }
      
   if(value=='Matte Black & Rose Gold'){
  $(this).css( "background-color", "#994c62" ); 
  } 
      
   if(value=='Matt Black & Rose Gold'){
  $(this).css( "background-color", "#994c62" ); 
  }
   
  if(value=='Autumn'){
  $(this).css( "background-color", "#DE8C3C" ); 
  }
      
  if(value=='Blossom'){
  $(this).css( "background-color", "#fee9d8" ); 
  }
      
  if(value=='Warm White'){
  $(this).css( "background-color", "#FDF4DC" ); 
  }
  
   if(value=='Matte Black/ Gun Metal'){
  $(this).css( "background-color", "#141617" ); 
  }
      
  if(value=='Gun Metal / Matte Black'){
  $(this).css( "background-color", "#625a56" ); 
  }
   
  if(value=='Matte Black White'){
  $(this).css( "background-color", "#bababa" ); 
  }
  
  if(value=='Brushed Nickel White'){
  $(this).css( "background-color", "#73706f" ); 
  }
  
  if(value=='Urban Brass White'){
  $(this).css( "background-color", "#bd9c6e" ); 
  }
      
  if(value=='Champagne'){
  $(this).css( "background-color", "#F7E7CE" ); 
  }
      
  if(value=='Chrome and Black'){
  $(this).css( "background-color", "#cfcfcf" ); 
  } 
  
  if(value=='Matte Pink'){
  $(this).css( "background-color", "#D288A2" ); 
  }
  
  if(value=='Silver Ring'){
  $(this).css( "background-color", "#C0C0C0" ); 
  } 
   
  if(value=='Matte Blue'){
  $(this).css( "background-color", "#4b6f83" ); 
  }
  
  if(value=='Matte Dark Grey'){
  $(this).css( "background-color", "#292a2e" ); 
  }
  
  if(value=='Matte Green'){
  $(this).css( "background-color", "#599e89" ); 
  }
  
  if(value=='Matte Black/ Brushed Nickel'){
  $(this).css( "background-color", "#302f34" ); 
  }
  
  if(value=='Matte Black/ Chrome'){
  $(this).css( "background-color", "#323337" ); 
  }
      
  if(value=='Brushed Nickel / Matte Black'){
  $(this).css( "background-color", "#c7c3be" ); 
  }
  
  if(value=='Matte Black/ Urban Brass'){
  $(this).css( "background-color", "#cdd3d7" ); 
  }
  
  if(value=='Chrome / Matte Black'){
  $(this).css( "background-color", "#312a22" ); 
  }
  
  if(value=='Urban Brass / Matte Black'){
  $(this).css( "background-color", "#d7ccaf" ); 
  }
      
  if(value=='Brass'){
  $(this).css( "background-color", "#B5A642" ); 
  }
      
   if(value=='Black Gold'){
  $(this).css( "background-color", "#281C02" ); 
  }
  
   if(value=='Gloss Black and white'){
  $(this).css( "background-color", "#efefef" ); 
  }
      
   if(value=='Urban Brass with Matte Black'){
  $(this).css( "background-color", "#efefef" ); 
  }  
  });
      
  











});


$(document).ready(function() {
  // Initially hide all the FAQ texts
  $('.faq-text').hide();

  // Handle click event on each FAQ item
  $('.faq-heading').click(function() {
    var $faqItem = $(this).parent(); // Get the parent .faq-item
    var $faqText = $faqItem.find('.faq-text'); // Find the .faq-text inside the clicked item
    var $faqArrow = $faqItem.find('.faq-arrow'); // Find the .faq-arrow inside the clicked item

    // Toggle visibility of the clicked FAQ's text
    $faqText.slideToggle();

    // Rotate the arrow based on the visibility of the text
    $faqArrow.css('transform', $faqText.is(':visible') ? 'rotate(-135deg)' : 'rotate(45deg)');

    // Close all other FAQ items
    $('.faq-item').not($faqItem).find('.faq-text').slideUp();
    $('.faq-item').not($faqItem).find('.faq-arrow').css('transform', 'rotate(45deg)');
  });
});

$(document).ready(function() {

    $('a.t4s-ch.cstm_popuop').click(function() {
        $('.cstmm_popuop_data').addClass('display_cstm_popup');  // Corrected class name
    });
   $('span.close_pop_cdtm').click(function() {
        $('.cstmm_popuop_data').removeClass('display_cstm_popup');  // Corrected class name
    });
});
$(document).ready(function() {
    $('button[name="add"]').click(function() {
        setTimeout(function() {
         
            $('body').removeClass('t4s-lock-scroll is--opend-drawer');
            $('body').addClass('visible_cstm'); // Correct method name: addClass
        }, 4000);  
    });
});

    
      
      